import { FunctionComponent, useEffect } from "react";
import { observer } from "mobx-react-lite";

import { BouncingDots } from "../../../components/Shared/LoadingSkeletons/BouncingDots/BouncingDots";
import { useThreadService } from "../../../services/ServiceHooks";
import { useStore } from "../../../stores/StoreContext";
import { ThreadHistoryList } from "./ThreadHistoryList/ThreadHistoryList";

const RawChatThreadHistory: FunctionComponent = () => {
  const { threadStore, chatStore } = useStore();

  const threadService = useThreadService();

  useEffect(() => {
    if (!threadStore.hasLoadedInitialThreadPage && !threadStore.hasThreadLoadError) {
      threadService.loadThreadsPage(0);
    }
  }, [threadService, threadStore.hasLoadedInitialThreadPage, threadStore.hasThreadLoadError]);

  // don't show loading spinner once we have threads
  if (!threadStore.hasLoadedInitialThreadPage && !threadStore.threads.length && !threadStore.hasThreadLoadError) {
    return <BouncingDots />;
  }

  return (
    <ThreadHistoryList
      threads={threadStore.threads}
      knowledgeBases={chatStore.knowledgeBases}
      activeThreadId={threadStore.activeThread?.id}
      showDateSeparators={true}
    />
  );
};

export const ChatThreadHistory = observer(RawChatThreadHistory);
